import { jsx as t } from "react/jsx-runtime";
import l from "./index.es5735.js";
import { TagIllustration as m } from "./index.es503.js";
import { ReportDailyFailedIllustration as n } from "./index.es491.js";
import { ChainIllustration as a } from "./index.es500.js";
import { DownloadAlertIllustration as s } from "./index.es499.js";
import { SentEmailIllustration as p } from "./index.es498.js";
import { PinAlertIllustration as e } from "./index.es497.js";
import { PinSuccessIllustration as u } from "./index.es496.js";
import { GetDemoIllustration as f } from "./index.es495.js";
import { ExpireIllustrationNoBackground as I } from "./index.es494.js";
import { ExpireIllustration as c } from "./index.es493.js";
import { BellIllustration as d } from "./index.es492.js";
import { ReportDailyIllustration as D } from "./index.es490.js";
import { EmailIllustration as x } from "./index.es489.js";
import { RestartIllustration as E } from "./index.es488.js";
import { LockIllustration as g } from "./index.es487.js";
import { UpsellIllustration as y } from "./index.es486.js";
import { DeleteIllustration as B } from "./index.es485.js";
const C = {
  DeleteIllustration: B,
  UpsellIllustration: y,
  LockIllustration: g,
  RestartIllustration: E,
  EmailIllustration: x,
  ReportDailyIllustration: D,
  BellIllustration: d,
  ExpireIllustration: c,
  ExpireIllustrationNoBackground: I,
  GetDemoIllustration: f,
  PinSuccessIllustration: u,
  PinAlertIllustration: e,
  SentEmailIllustration: p,
  DownloadAlertIllustration: s,
  ChainIllustration: a,
  ReportDailyFailedIllustration: n,
  TagIllustration: m
}, J = ({
  illustration: o,
  testId: r
}) => {
  const i = C[o];
  return /* @__PURE__ */ t("div", { className: l.iconContainer, "data-testid": r, children: /* @__PURE__ */ t(i, {}) });
};
export {
  J as ConfirmationDialogBoxIllustration,
  C as confirmationIllustrationIcons
};
//# sourceMappingURL=index.es874.js.map
